@file:Suppress("MagicNumber")

package com.nonopn.skydome.common.app.pages.sharing

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Share
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.action_share
import com.nonopn.skywatcher.common.app.res.share_email
import com.nonopn.skywatcher.common.app.res.share_via
import com.nonopn.skywatcher.design.utils.localized

/**
 * Reusable share button — Strike Radar Phase 3.
 * Displays a dropdown menu with available sharing options.
 *
 * @param title Document title to share
 * @param shareContent Text content to share
 * @param shareManager ShareManager instance (injected by caller)
 * @param modifier Optional Compose modifier
 */
@Composable
fun ShareButton(
    title: String,
    shareContent: String,
    shareManager: ShareManager,
    modifier: Modifier = Modifier
) {
    var showMenu by remember { mutableStateOf(false) }

    Box(modifier = modifier) {
        OutlinedButton(
            onClick = { showMenu = true },
            colors = ButtonDefaults.outlinedButtonColors(
                contentColor = Color(0xFF2B7FE0)
            ),
            border = BorderStroke(1.dp, Color(0xFF2B7FE0)),
            shape = RoundedCornerShape(10.dp)
        ) {
            Icon(
                imageVector = Icons.Default.Share,
                contentDescription = null,
                modifier = Modifier.size(16.dp)
            )
            Spacer(Modifier.width(6.dp))
            Text(
                Res.string.action_share.localized(),
                fontSize = 13.sp,
                fontWeight = FontWeight.SemiBold
            )
        }

        DropdownMenu(
            expanded = showMenu,
            onDismissRequest = { showMenu = false }
        ) {
            DropdownMenuItem(
                text = { Text("📧 ${Res.string.share_email.localized()}") },
                onClick = {
                    showMenu = false
                    shareManager.shareText(title, shareContent)
                }
            )
            DropdownMenuItem(
                text = { Text("📤 ${Res.string.share_via.localized()}") },
                onClick = {
                    showMenu = false
                    shareManager.shareText(title, shareContent)
                }
            )
        }
    }
}
